import mutations from './occupationHealthEmployabilityReport.mutations'
import actions from './occupationHealthEmployabilityReport.actions'
import getters from './occupationHealthEmployabilityReport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
